import { NgModule, inject } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoggerModule, NGXLogger } from 'ngx-logger';

const routes: Routes = [
  /**
   * This route is used to catch all unknown routes and redirect to the root.
   * It must ALWAYS be the last route in the array.
   * See: https://angular.dev/guide/routing/common-router-tasks#setting-up-wildcard-routes
   */
  {
    path: '**',
    redirectTo: (redirectData) => {
      const logger = inject(NGXLogger);
      logger.error('Unknown route. Redirecting to root.', redirectData.url);

      return '';
    },
  },
];

@NgModule({
  imports: [LoggerModule.forChild(), RouterModule.forChild(routes)],
})
export class NotFoundRouteModule {}
